import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { CircularProgress } from '../../../../../../../components/circular-progress';

type ChartEmptyContainerProps = {
  isLoading: boolean;
  height?: number;
};

export const ChartEmptyContainer: React.FC<ChartEmptyContainerProps> = ({ isLoading, height = 250 }) => {
  const { t } = useTranslation('channel-details');

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height }}>
      {!isLoading ? (
        <Typography fontWeight={700} fontSize={18} fontFamily={`"Manrope", sans-serif`}>
          {t('chartEmptyState.header')}
        </Typography>
      ) : (
        <CircularProgress />
      )}
    </Stack>
  );
};
